import MicroloansImage from '../../assets/images/microloans.webp';
import { CloseWebviewEvent } from '../../sdk/close.webview.event';
import ArrowUpDownIcon from '../../components/shared/Icons/ArrowUpDownIcon';
import CreditFilled from '../../components/shared/Icons/CreditFilled';
import InstallmentsFilled from '../../components/shared/Icons/InstallmentsFilled';
import ConfirmCircleFilled from '../../components/shared/Icons/ConfirmCircleFilled';

export const OutlineOnboardingType = {
  MICROLOAN: 'MICROLOAN',
};

export const OutlineOnboardingProvider = t => {
  return {
    [OutlineOnboardingType.MICROLOAN]: {
      image: MicroloansImage,
      title: t('How credit works'),
      subtitle: '',
      ctaText: t('Use credit'),
      eventName: t('microloan_outline'),
      ctaAction: () => {
        CloseWebviewEvent.closedByUser();
      },
      list: [
        {
          icon: <ArrowUpDownIcon color="#000" />,
          title: t('Click "use credit"'),
          subtitle: t(
            'We\'ve loaned credit to your credit line. Click "use credit" from your wallet anytime to move it to your current account and spend it like cash.',
          ),
        },
        {
          icon: <CreditFilled />,
          title: t('Select amount'),
          subtitle: t(
            "You'll be prompted to enter the amount you want to move to your current account",
          ),
        },
        {
          icon: <InstallmentsFilled />,
          title: t('Select installments'),
          subtitle: t(
            "You'll repay loaned money to your current account in installments. When prompted, choose the installment plan you'd like to use",
          ),
        },
        {
          icon: <ConfirmCircleFilled />,
          title: t('Confirm'),
          subtitle: t('Review your selections and confirm your transaction'),
        },
      ],
      onCloseClick: () => {
        CloseWebviewEvent.closedByUser();
      },
    },
  };
};
